import { isApiError } from '@/core/http';

/** Mensagem do erro de uma ação, em português, sem detalhe técnico. */
export function actionError(error: unknown): string {
  if (isApiError(error)) {
    if (error.is('invalid_visit_transition', 'visit_not_found'))
      return 'Este pedido mudou enquanto você olhava — a tela já foi atualizada.';
    if (error.is('invalid_visit') && error.context.field === 'scheduled_for')
      return 'A visita precisa ser num horário futuro.';
    if (error.is('forbidden')) return 'Seu perfil não pode mais mexer em pedidos de visita.';
    if (error.is('network_error')) return error.message;
  }
  return 'Não foi possível salvar agora. Tente novamente.';
}
